import type { FaireProductEntity } from "../../entity_types/product";

export const p_w2v053z: FaireProductEntity = {
  token: "p_w2v053z",
  type: "product",
  name: "Sparkling Mineral Water",
  brandName: "Pure Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c0ee2a474a3a944d25643290747265441da36bd4982aa3bdff84fdacba4dcf7b.webp",
  priceDollars: 7,
  description: "Refreshing sparkling mineral water",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "tea"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/c0ee2a474a3a944d25643290747265441da36bd4982aa3bdff84fdacba4dcf7b.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  inStock: true,
};
